export const openVideoModal = () => ({
  type: "OPEN_FULLSCREEN_VIDEO_MODAL"
});

export const closeVideoModal = () => ({
  type: "CLOSE_FULLSCREEN_VIDEO_MODAL"
});
